<nav id="mainNavigation">
    <ul>
        <li><a routerLink="/dashboard" routerLinkActive="active"><img src="./../../../../assets/dashboard.svg"> Dashboard</a></li>
        <li><a routerLink="/bookings" routerLinkActive="active"><img src="./../../../../assets/bookings.svg"> Buchungen</a></li>
        <li><a routerLink="/content" routerLinkActive="active"><img src="./../../../../assets/content.svg"> Daten</a></li>
        <li><a routerLink="/logout"><img src="./../../../../assets/logout.svg"> Logout</a></li>
    </ul>
</nav>